//ALL REACT
import * as React from 'react';
//MUI COMPONENTS
import { Typography, TextField, Button, FormControl, Select, MenuItem, InputLabel, Tooltip, Icon } from '@mui/material';
//MUI ICONS
import { EditDocument, Help } from '@mui/icons-material';
//STYLES
import styles from '../../../module_css/formsCatalogs.module.css';
//PICTURES
import imgUpdateOwner from '../../../assets/svg/updateOwner.svg';
//API CONTROLLER
import ApiController from '../../../controllers/api';
//CUSTOM COMPONENTS
import CustomBackdrop from '../../CustomBackdrop';
//OTHERS
import Swal from 'sweetalert2';

const ERROR_MESSAGES = {
  required:  "EL CAMPO ES OBLIGATORIO",
  invalid:   "EL VALOR DEL CAMPO NO CUMPLE CON EL FORMATO",
  minLength: "EL VALOR DEL CAMPO ES DEMASIADO CORTO",
  maxLength: "EL VALOR DEL CAMPO ES DEMASIADO LARGO"
};
const PROPERTIES_ENTRIES = {
    responsable : {
      required: true,
      pattern: /^[A-ZÁÉÍÓÚÜÑ\s]+$/,
      minLength: 10,
      maxLength: 100
    },
    abrev:{
      required: true,
      pattern: /^[0-9]\d*$/
    },
    descripcionCargo:{
      required: true,
      pattern: /^[A-ZÁÉÍÓÚÜÑ0-9 .,\'"()\-\:;\/]+$/,
      minLength: 10,
      maxLength: 150
    }
}

export default function FormEditOwnerArea ({ id = null, handleClose, refreshArea }){
  const [constants, setConstants] = React.useState({
    grades:[]
  });
  const [openBackdrop, setOpenBackdrop] = React.useState(false);
  const [data, setData] = React.useState({
    responsable: "",
    abrev: 0,
    descripcionCargo: ""
  });
  const [errors, setErrors] = React.useState({
    responsable: [],
    abrev: [],
    descripcionCargo: []
  });
  const apiInstance = React.useMemo(() => new ApiController(process.env.REACT_APP_API_URL), []);
  const getConstants = async () => await apiInstance.get(`/area/constants/`);
  const updateData = async (data) => await apiInstance.put(`/area/change-owner/${id}`,data);

  const handleChange = (e) => {//CONTROLA LAS ENTRADAS DE LOS INPUTS
    const { name, value } = e.target;
    setData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  React.useEffect(() => {
    (async () => {
      setOpenBackdrop(true);
      const responseConstants = await getConstants();
     if(responseConstants.success){
        setConstants({
          grades: responseConstants.data.GRADOS_RESPONSABLES
        });
      }else{
        Swal.fire({
          title: '¡ERROR! ❌',
          icon: 'error',
          text: 'NO SE PUDIERON CARGAR LOS DATOS',
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonColor:'#ef7474',
          confirmButtonText: 'CONFIRMAR',
          padding: '0 0 20px'
        });
      handleClose();
      }
      setOpenBackdrop(false);
    })();
  }, [id]);

  const validateFieldGeneric = (value, options = {}, fieldName) => {
    const errors = [];
    const exemptFields = ['abrev'];
    if(!(exemptFields.includes(fieldName) && value===0)){ // SE HACE UNA EXCEPCION DE LOS SELECT
    if (options.required && !value) errors.push({ type: "required" });
    }
    if (value && options.pattern && !options.pattern.test(value)) errors.push({ type: "invalid" });
    if (value && options.minLength && value.length < options.minLength) errors.push({ type: "minLength" });
    if (value && options.maxLength && value.length > options.maxLength) errors.push({ type: "maxLength" });
    return errors;
  };

  const validateAllFields = () => {
    const newErrors = {};
    for (const field in PROPERTIES_ENTRIES) {
      newErrors[field] = validateFieldGeneric(data[field], PROPERTIES_ENTRIES[field], field);
    }
    setErrors(newErrors);
    return !Object.values(newErrors).some(fieldErrors => fieldErrors.length > 0);
  };

  const getHelperText = (field) => {
    return errors[field].map(e => "- *" + ERROR_MESSAGES[e.type]).join("\n") || "";
  };

  const buildPayload = (data) => ({
    RESPONSABLE: data.responsable,
    ABREV: data.abrev,
    DESCRIPCION_CARGO: data.descripcionCargo
  });

 const handleSubmit = (event) => {
  event.preventDefault();
  if (!validateAllFields()) return;
    Swal.fire({
      title: "ACTUALIZAR EL TITULAR DEL ÁREA ⚠️",
      text: "¿ESTAS SEGURO QUE DESEAS ACTUALIZAR EL TITULAR DE ESTA ÁREA?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "SI, ACTUALIZAR TITULAR",
      confirmButtonColor: "#990E3F",
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then(async (result) => {
      if (result.isConfirmed) {
          const res = await updateData(buildPayload(data));
          if (res.success) {
            Swal.mixin({
              toast: true,
              position: "bottom-start",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            }).fire({
              icon: "success",
              title: "ÁREA ACTUALIZADA",
              text: "SE ACTUALIZO CORRECTAMENTE"
            });
            handleClose();
            if (refreshArea) refreshArea();
          }else{
            Swal.fire({
                title: '¡ERROR! ❌',
                icon: 'error',
                text: 'NO SE PUDIERÓN ACTUALIZAR LOS DATOS DEL ÁREA',
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor:'#ef7474',
                confirmButtonText: 'CONFIRMAR',
                padding: '0 0 20px'
              });
          }
          handleClose();
          setOpenBackdrop(false);
      }
    });
  };
  return (
    <>
      <CustomBackdrop open={openBackdrop}/>
      <form className={styles.container_main_form} onSubmit={handleSubmit}>
        <img src={imgUpdateOwner} alt="Logo" className={styles.logo_form}/>
        <Typography variant="h6" gutterBottom align='center'>CAMBIAR TITULAR DEL ÁREA</Typography>
        <Tooltip 
        sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxHeight: '90vh',
      bgcolor: 'background.paper',
      boxShadow: 24,
      borderRadius: 1,
      overflowY: 'auto',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': { display: 'none' }
    }}
        title="RECUERDA QUE UNA VEZ QUE HAYA UN CAMBIO DE TITULAR, LOS BIENES EN TU ÁREA NO ESTARAN DESIGNADOS A UN VALE DE RESGUARDO." placement="bottom-start">
          <Help
            sx={{
            position: 'absolute',
            top: 55,
            right: 17,
            color: (theme) => theme.palette.grey[500],
            cursor:"help"
          }}
          />
        </Tooltip>
        <TextField
          label="NOMBRE DEL NUEVO TITULAR DEL ÁREA"
          variant="outlined"
          autoComplete="off"
          fullWidth
          className={styles.textField_form}
          name="responsable"
          value={data.responsable}
          onChange={handleChange}
          error={errors.responsable.length > 0}
          helperText={getHelperText("responsable")}
          sx={{
            '& .MuiFormHelperText-root': {
              whiteSpace: 'pre-line'
            }
          }} 
        />
        <FormControl 
        variant="outlined"
        sx={{ mt: 1, mb: 1 }}
        fullWidth
        error={errors.abrev.length > 0}
        >
          <InputLabel id="grado-label">GRADO DEL NUEVO RESPONSABLE</InputLabel>
          <Select
            labelId="grado-label"
            id="grado-select"
            name="abrev"
            value={data.abrev}
            onChange={handleChange}
            label="GRADO DEL RESPONSABLE"
          >
            {(constants.grades).map((grado) => (
              <MenuItem key={grado.value} value={grado.value}>
                {grado.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="DESCRIPCIÓN DEL CARGO"
          multiline
          rows={3}
          fullWidth
          className={styles.textField_form}
          variant="outlined"
          name="descripcionCargo"
          value={data.descripcionCargo}
          onChange={handleChange}
          error={errors.descripcionCargo.length > 0}
          helperText={getHelperText("descripcionCargo")}
          sx={{
            '& .MuiFormHelperText-root': {
              whiteSpace: 'pre-line'
            }
          }} 
        />
        <Button
          variant="contained"
          size="large"
          startIcon={<EditDocument />}
          className={styles.button_form}
          type="submit"
          fullWidth
          sx={{
              backgroundColor: "#990E3F",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#870C38"
               }
          }}
        >
            CAMBIAR DE TITULAR
        </Button>
      </form>
    </>
  );
};